/**
 * 人工标定的相机视角（相对地表 height + heading/pitch）
 * 由「保存相机视角」采集
 */

/** 由相机参数推算地面注视点（标签/特效应落在此处，而非相机正下方） */
export function cameraLookAt(cam) {
  const lng = cam.lng;
  const lat = cam.lat;
  const height = Math.max(cam.height ?? 1000, 50);
  const pitchDeg = Math.abs(cam.pitch ?? -45);
  const headingDeg = cam.heading ?? 0;

  // 近垂直俯视：注视点≈相机投影
  if (pitchDeg >= 85) {
    return { lng, lat };
  }
  // 近水平：向前取一段距离
  const pitchRad = (Math.min(pitchDeg, 80) * Math.PI) / 180;
  const headingRad = (headingDeg * Math.PI) / 180;
  const dist = height / Math.tan(pitchRad); // 米
  const latRad = (lat * Math.PI) / 180;
  const dLat = (dist * Math.cos(headingRad)) / 111320;
  const dLng =
    (dist * Math.sin(headingRad)) / (111320 * Math.cos(latRad));
  return {
    lng: lng + dLng,
    lat: lat + dLat,
  };
}

export const CAMERA_DEFAULT = {
  lng: 106.190433,
  lat: 38.231446,
  height: 17267,
  heading: 7.5,
  pitch: -33.1,
};

export const CAMERA_CORE = {
  lng: 106.131382,
  lat: 38.455095,
  height: 11199,
  heading: 0.5,
  pitch: -68,
};

export const CAMERA_CONE = {
  lng: 106.222535,
  lat: 38.445916,
  height: 2423,
  heading: 2.5,
  pitch: -30.1,
};

export const CAMERA_STATION = {
  lng: 106.169485,
  lat: 38.476762,
  height: 1103,
  heading: 0,
  pitch: -36,
};

export const CAMERA_OLDTOWN = {
  lng: 106.276706,
  lat: 38.438184,
  height: 2481,
  heading: 14.4,
  pitch: -49.7,
};

export const CAMERA_HUABO = {
  lng: 106.201262,
  lat: 38.503698,
  height: 5025,
  heading: 7.9,
  pitch: -51.1,
};

export const CAMERA_OVERVIEW = {
  lng: 106.222506,
  lat: 38.47075,
  height: 33976,
  heading: 0,
  pitch: -88,
};

/** 各场景注视点（标签 / 核心区特效落点） */
export const FOCUS_CORE = cameraLookAt(CAMERA_CORE);
export const FOCUS_CONE = cameraLookAt(CAMERA_CONE);
export const FOCUS_STATION = cameraLookAt(CAMERA_STATION);
export const FOCUS_OLDTOWN = cameraLookAt(CAMERA_OLDTOWN);
export const FOCUS_HUABO = cameraLookAt(CAMERA_HUABO);
export const FOCUS_OVERVIEW = cameraLookAt(CAMERA_OVERVIEW);
